module.exports = __webpack_public_path__ + "img/Flag_of_Mali.12f23b6b.svg";